'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _IconComponent = require('../icon/IconComponent');

var _IconComponent2 = _interopRequireDefault(_IconComponent);

var _language = require('../language');

var _convertDataOptions = require('../utils/convertDataOptions');

var _UtilApi = require('../utils/UtilApi');

var _UtilLodash = require('../utils/UtilLodash');

require('./css/index-new.scss');

require('antd/lib/tree-select/style/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeSelect = (0, _component2.default)(function () {
    return import('antd/lib/tree-select');
});
var SHOW_PARENT = TreeSelect.SHOW_PARENT;


function findPath(value, data, pathlevel, pathStartLevel, separator) {
    var sel = '';
    pathlevel = pathlevel || 10;
    pathStartLevel = pathStartLevel || 0;
    var k = 0;
    function loop(selected, children) {
        for (var i = 0; i < children.length; i++) {
            var item = children[i];
            if (selected == item.value && k < pathlevel) {
                k++;
                sel = sel ? '' + item.title + separator + sel : '' + item.title;
                return;
            }
            if (item.children) {
                loop(selected, item.children);
                if (sel.length > 0 && k < pathlevel) {
                    k++;
                    sel = sel ? '' + item.title + separator + sel : '' + item.title;
                    return;
                }
            }
        }
    }
    loop(value, data);
    return sel.split(separator).slice(pathStartLevel).join(separator);
}

var IDTreeCombobox = function (_BaseComponent) {
    (0, _inherits3.default)(IDTreeCombobox, _BaseComponent);

    function IDTreeCombobox(props) {
        (0, _classCallCheck3.default)(this, IDTreeCombobox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IDTreeCombobox.__proto__ || (0, _getPrototypeOf2.default)(IDTreeCombobox)).call(this, props));

        _this.handleChange = function (value, object, extra) {
            if (value != _this.state.value) {
                var newValue = value;
                var valueObject = _lodash2.default.get(extra, 'triggerNode.props');
                var pathInText = _this.props.pathInText;

                if (value && pathInText) {
                    if (_this.getIsMultiple()) {
                        var _value = [];
                        value.forEach(function (val) {
                            _value.push(val.value ? val.value : val);
                        });
                        newValue = _value;
                    } else {
                        newValue = value.value;
                    }
                }
                if (!(0, _UtilLodash.checkIsEmpty)(newValue) && _this.state.value !== newValue) {
                    _this.setValue(newValue, valueObject);
                } else {
                    _this.setValue(undefined);
                }
            }
        };

        _this.onSelect = function (value, node, extra) {
            var onSelect = _this.props.onSelect;

            onSelect && onSelect(value, node, extra);
        };

        _this.filterOption = function (keySearch, node) {
            var filterOption = _this.props.filterOption;

            if (filterOption) {
                return filterOption(node, keySearch);
            }
            if (!keySearch) {
                return true;
            }
            if (_this.boDauTiengViet(_lodash2.default.get(node, 'props.title', '')).indexOf(_this.boDauTiengViet(keySearch)) > -1) {
                return true;
            }
            return false;
        };

        _this.getPopupContainer = function (trigger) {
            var _this$props = _this.props,
                popupContainer = _this$props.popupContainer,
                popupContainerCls = _this$props.popupContainerCls;

            if (!popupContainer) {
                return document.body;
            } else if (popupContainerCls) {
                return trigger.parentNode.closest('.' + popupContainerCls);
            }
            return trigger.parentNode.closest('.popup-container') || document.body;
        };

        var options = props.parseTree ? (0, _convertDataOptions.convertFlatDataToTree)(props.options, props.valueKey) : props.options;
        _this.state = {
            prevProps: props,
            value: (0, _UtilApi.getProxy)(props) ? "" : !_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue,
            expandedKeys: _this.getTreeExpandedKeys(options),
            options: (0, _UtilApi.getProxy)(props) ? [] : props.parseTree ? options : props.options
        };
        _this.dataTestID = 'tree-combo';
        return _this;
    }

    (0, _createClass3.default)(IDTreeCombobox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value,
                options = nextProps.options,
                parseTree = nextProps.parseTree;

            var nextProxy = (0, _UtilApi.getProxy)(nextProps);
            var preProxy = (0, _UtilApi.getProxy)(this.props);

            var diffValue = false;
            var diffUrl = false;
            var diffOptions = false;

            if (!_lodash2.default.isEqual(nextProxy, preProxy)) {
                diffUrl = true;
            }

            if (this.compareOptions(options, this.props.options)) {
                diffOptions = true;
            }

            if (this.compareValue(nextProps.value)) {
                diffValue = true;
            }

            if (diffUrl) {
                this.loadData(nextProxy);
            } else if (diffOptions) {
                var newOptions = parseTree ? (0, _convertDataOptions.convertFlatDataToTree)(options, nextProps.valueKey) : options;
                this.setState({
                    options: newOptions,
                    expandedKeys: this.getTreeExpandedKeys(newOptions),
                    value: diffValue ? value : this.props.value
                });
            } else if (diffValue) {
                this.setState({
                    value: value
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var proxy = (0, _UtilApi.getProxy)(this.props);
            if (proxy) {
                this.loadData(proxy, function (options) {
                    _this2.setState({
                        options: options,
                        value: !_this2.checkIsEmptyOrNull(_this2.props.value) ? _this2.props.value : _this2.props.defaultValue,
                        expandedKeys: _this2.getTreeExpandedKeys(options)
                    });
                });
            }
        }
    }, {
        key: 'setData',
        value: function setData(options, value) {
            var _props = this.props,
                parseTree = _props.parseTree,
                valueKey = _props.valueKey;

            var newOptions = parseTree ? (0, _convertDataOptions.convertFlatDataToTree)(options, valueKey) : options;
            this.setState({
                options: newOptions,
                value: value,
                expandedKeys: this.getTreeExpandedKeys(newOptions)
            });
        }
    }, {
        key: 'getTreeExpandedKeys',
        value: function getTreeExpandedKeys(options) {
            var treeExpandedKeys = this.props.treeExpandedKeys;

            if (treeExpandedKeys) {
                return treeExpandedKeys;
            }
            var expandedKeys = ['root'];
            this.progressTreeExpandedKeys(options, expandedKeys);
            return expandedKeys;
        }
    }, {
        key: 'progressTreeExpandedKeys',
        value: function progressTreeExpandedKeys(options, expandedKeys) {
            var _this3 = this;

            var _props2 = this.props,
                valueKey = _props2.valueKey,
                expandAll = _props2.expandAll;

            _lodash2.default.each(options, function (option) {
                if (!_lodash2.default.isEmpty(option.children)) {
                    if (_lodash2.default.get(option, valueKey) !== undefined) {
                        if (expandAll || _lodash2.default.get(option, 'expanded')) {
                            expandedKeys.push(_lodash2.default.get(option, valueKey, '').toString());
                        }
                    }
                    _this3.progressTreeExpandedKeys(option.children, expandedKeys);
                }
            });
        }
    }, {
        key: 'loadData',
        value: function loadData(proxy, callback) {
            var _this4 = this;

            var _props3 = this.props,
                parseTree = _props3.parseTree,
                valueKey = _props3.valueKey;

            if (!_lodash2.default.isObject(proxy)) {
                _axios2.default.get(proxy).then(function (response) {
                    var data = _lodash2.default.get(response, (0, _UtilApi.getRootProperty)(_this4.props));
                    var options = parseTree ? (0, _convertDataOptions.convertFlatDataToTree)(data, valueKey) : data;
                    if (callback) {
                        callback(options);
                    } else {
                        _this4.setState({
                            options: options,
                            expandedKeys: _this4.getTreeExpandedKeys(options)
                        });
                    }
                });
            } else {
                var loadCallback = proxy.loadCallback;


                var config = {};
                (0, _UtilApi.setConfigAxios)(config, proxy);

                (0, _axios2.default)(config).then(function (response) {
                    var data = [];
                    if (loadCallback) {
                        data = loadCallback(response);
                    } else {
                        data = _lodash2.default.get(response, (0, _UtilApi.getRootProperty)(_this4.props));
                    }
                    var options = parseTree ? (0, _convertDataOptions.convertFlatDataToTree)(data, valueKey) : data;
                    if (callback) {
                        callback(options);
                    } else {
                        _this4.setState({
                            options: options,
                            expandedKeys: _this4.getTreeExpandedKeys(options)
                        });
                    }
                });
            }
        }
    }, {
        key: 'getTreeData',
        value: function getTreeData(options) {
            var _props4 = this.props,
                treeLine = _props4.treeLine,
                disabledNodes = _props4.disabledNodes,
                titleRoot = _props4.titleRoot,
                label = _props4.label,
                valueKey = _props4.valueKey,
                labelKey = _props4.labelKey,
                rootNode = _props4.rootNode;

            if ((0, _UtilLodash.checkIsEmpty)(options)) {
                return [];
            } else if (treeLine && rootNode) {
                var root = {
                    title: titleRoot || '--- ' + label + ' ---',
                    disabled: true,
                    value: 'root',
                    children: (0, _convertDataOptions.getOptions)(options, valueKey, labelKey, disabledNodes)
                };
                return [root];
            }
            return (0, _convertDataOptions.getOptions)(options, valueKey, labelKey, disabledNodes);
        }
    }, {
        key: 'getIsMultiple',
        value: function getIsMultiple() {
            var _props5 = this.props,
                isMulti = _props5.isMulti,
                multiple = _props5.multiple;

            return isMulti || multiple;
        }
    }, {
        key: 'convertValue',
        value: function convertValue(value) {
            if (!this.getIsMultiple()) {
                if (!_lodash2.default.isObject(value)) {
                    return value ? value.toString() : value;
                }
                return _lodash2.default.get(value, 'value') ? _lodash2.default.get(value, 'value').toString() : _lodash2.default.get(value, 'value');
            }
            return value;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props6 = this.props,
                className = _props6.className,
                style = _props6.style,
                disabled = _props6.disabled,
                readOnly = _props6.readOnly,
                expandAll = _props6.expandAll,
                isClearable = _props6.isClearable,
                pathInText = _props6.pathInText,
                pathlevel = _props6.pathlevel,
                choiceTransitionName = _props6.choiceTransitionName,
                treeLine = _props6.treeLine,
                classNameWrap = _props6.classNameWrap,
                iconLine = _props6.iconLine,
                iconCls = _props6.iconCls,
                icon = _props6.icon,
                iconType = _props6.iconType,
                valueKey = _props6.valueKey,
                pathStartLevel = _props6.pathStartLevel,
                separator = _props6.separator,
                rootNode = _props6.rootNode;
            var _state = this.state,
                options = _state.options,
                value = _state.value;

            var _value = null;
            if (pathInText && value && !_lodash2.default.has(value, valueKey)) {
                if (this.getIsMultiple()) {
                    _value = [];
                    value.forEach(function (val) {
                        if (!_lodash2.default.has(val, valueKey)) {
                            var newTitle = findPath(val, options, pathlevel, pathStartLevel, separator);
                            _value.push({ value: val, label: newTitle });
                        } else {
                            _value.push(val);
                        }
                    });
                } else {
                    var newTitle = findPath(value, options, pathlevel, pathStartLevel, separator);
                    _value = { value: value, label: newTitle };
                }
            } else {
                _value = (0, _UtilLodash.checkIsEmpty)(value) ? undefined : value;
            }

            if (this.getIsMultiple() && !value) {
                _value = [];
            }

            var dropdownStyle = {
                maxHeight: 300
            };

            if (this.props.dropdownWidth) {
                dropdownStyle.minWidth = this.props.dropdownWidth;
            }

            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    className: (0, _classnames2.default)('body-wrap treeSelect', classNameWrap, { 'input-disabled': disabled, 'read-only': readOnly }),
                    style: (0, _assign2.default)({}, style, { position: 'relative' })
                },
                _react2.default.createElement(TreeSelect, (0, _extends3.default)({
                    ref: function ref(c) {
                        return _this5.TreeSelect = c;
                    }
                }, _lodash2.default.omit(this.props, ['titleRoot']), {
                    className: (0, _classnames2.default)({ 'tree-select-line': treeLine }, className),
                    dropdownClassName: (0, _classnames2.default)("id-tree-select-dropdown", this.getSubDataTestId('picker'), { "id-tree-has-root-node": rootNode }, className),
                    dropdownStyle: (0, _assign2.default)({}, this.props.dropdownStyle, dropdownStyle),
                    choiceTransitionName: choiceTransitionName,
                    multiple: this.getIsMultiple(),
                    labelInValue: pathInText,
                    showSearch: true,
                    treeData: this.getTreeData(options),
                    treeIcon: false,
                    value: this.convertValue(_value),
                    allowClear: disabled === true ? false : isClearable,
                    showCheckedStrategy: SHOW_PARENT,
                    treeDefaultExpandAll: expandAll,
                    treeExpandedKeys: this.state.expandedKeys,
                    treeLine: treeLine,
                    onChange: this.handleChange,
                    onSelect: this.onSelect,
                    getPopupContainer: this.getPopupContainer,
                    suffixIcon: !readOnly && _react2.default.createElement(_IconComponent2.default, {
                        iconCls: iconCls,
                        iconType: this.getIsMultiple() ? _lodash2.default.get(_ConfigGlobal2.default, 'iconType.multiSelect') : iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.select'),
                        iconLine: iconLine
                    }),
                    clearIcon: !readOnly && isClearable ? _react2.default.createElement(_ButtonClear2.default, { onClick: this.onClear }) : _react2.default.createElement('span', null),
                    inputIcon: !readOnly && _react2.default.createElement(_IconComponent2.default, {
                        iconType: iconType,
                        iconCls: iconCls,
                        icon: icon,
                        iconLine: iconLine
                    }),
                    filterTreeNode: this.filterOption,
                    placeholder: '',
                    onTreeExpand: function onTreeExpand(expandedKeys) {
                        _this5.setState({ expandedKeys: expandedKeys });
                    },
                    onSearch: function onSearch(string) {
                        var onSearch = _this5.props.onSearch;

                        onSearch && onSearch(string);
                        if (string) {
                            _this5.Placeholder && _this5.Placeholder.hidden();
                        } else {
                            _this5.Placeholder && _this5.Placeholder.show();
                        }
                    },
                    onDropdownVisibleChange: function onDropdownVisibleChange(open) {
                        var onDropdownVisibleChange = _this5.props.onDropdownVisibleChange;

                        onDropdownVisibleChange && onDropdownVisibleChange(open);
                        if (open) {
                            setTimeout(function () {
                                var eles = document.querySelectorAll('.ant-select-dropdown');
                                _lodash2.default.each(eles, function (ele) {
                                    var scrollBar = ele.querySelector('.ant-select-tree-list-scrollbar');
                                    if (scrollBar) {
                                        if (!scrollBar.classList.contains('show-scrollbar')) {
                                            var holder = ele.querySelector('.ant-select-tree-list-holder > div');
                                            if (holder && holder.clientHeight > 256) {
                                                scrollBar.classList.add('show-scrollbar');
                                            }
                                        }
                                    }
                                }, 0);
                            });
                        }
                    }
                })),
                this.renderPlaceholder()
            );
        }
    }]);
    return IDTreeCombobox;
}(_BaseComponent3.default);

exports.default = IDTreeCombobox;


IDTreeCombobox.defaultProps = {
    expandAll: true,
    isClearable: true,
    iconCls: "",
    iconType: "caret-down",
    isSearchable: true,
    visibleIcon: true,
    notFoundContent: (0, _language.t)('No results were found'),
    treeNodeFilterProp: 'title',
    parseTree: false,
    rootProperty: 'data.results',
    choiceTransitionName: '',
    titleRoot: (0, _language.t)('--- Select ---'),
    treeLine: true,
    disabledNodes: [],
    rootNode: true,
    popupContainer: true,
    valueKey: 'value',
    labelKey: 'label',
    placeholder: (0, _language.t)("Select..."),
    separator: "/",
    virtual: true,
    treeCheckable: false,
    showArrow: true
};